import { CommonResponse } from '@xver/@types/api';
import {
    BackupDeletes,
    BackupSetting,
    BackupWithResponse,
    UpdateBackupSettingRequest,
} from '@xver/@types/backup';
import httpClient from '@xver/libs/axios';

const ENDPOINTS = {
    TOGGLE: (instanceID: number) => `/v1/backups/settings/${instanceID}/toggle`,
    GET_SETTING: (instanceID: number) => `/v1/backups/settings/${instanceID}`,
    UPDATE_SETTING: (instanceID: number) => `/v1/backups/settings/${instanceID}`,
    GET_ALL: (instanceID: number, page?: number) => `/v1/backups/${instanceID}?page=${page}`,
    FORCE: (instanceID: number) => `/v1/backups/${instanceID}`,
    RESTORE: (instanceID: number, backupID: number) =>
        `/v1/backups/restore/${instanceID}/${backupID}`,
    DELETE: (instanceID: number) => `/v1/backups/${instanceID}/delete`,
};

export function toggleBackup(instanceID: number): Promise<CommonResponse> {
    return httpClient.post(ENDPOINTS.TOGGLE(instanceID));
}

export function getBackupSetting(instanceID: number): Promise<BackupSetting> {
    return httpClient.get(ENDPOINTS.GET_SETTING(instanceID));
}

export function updateBackupSetting(
    instanceID: number,
    body: UpdateBackupSettingRequest
): Promise<CommonResponse> {
    return httpClient.post(ENDPOINTS.UPDATE_SETTING(instanceID), body);
}

export function getAllBackup(instanceID: number, page?: number): Promise<BackupWithResponse> {
    return httpClient.get(ENDPOINTS.GET_ALL(instanceID, page));
}

export function forceBackup(instanceID: number): Promise<CommonResponse> {
    return httpClient.post(ENDPOINTS.FORCE(instanceID));
}

export function restoreBackup(instanceID: number, backupID: number): Promise<CommonResponse> {
    return httpClient.post(ENDPOINTS.RESTORE(instanceID, backupID));
}

export function deleteBackup(instanceID: number, body: BackupDeletes): Promise<CommonResponse> {
    return httpClient.post(ENDPOINTS.DELETE(instanceID), body);
}
